import { useEffect, useState } from "react";
import { useSensorsStore } from "../../context/useSensorsStore";
import { useUserAuthStore } from "../../context/useUserAuthStore";
import Modal from "../ui/Modal";


function SensorForm({ initial, onSubmit }) {
    const [form, setForm] = useState(
        initial ?? {
            IMEI: "",
            cellNumber: "",
            type: "Tracker",
        }
    );
    const change = (e) => setForm({ ...form, [e.target.name]: e.target.value });
    return (
        <form className="form-grid" onSubmit={(e) => { e.preventDefault(); onSubmit(form); }}>
            <input name="IMEI" placeholder="IMEI" value={form.IMEI} onChange={change} required />
            <input name="cellNumber" placeholder="Cell number" value={form.cellNumber} onChange={change} />
            <input name="type" placeholder="Type" value={form.type} onChange={change} />
            <div className="form-actions"><button type="submit">Save</button></div>
        </form>
    );
}

export default function SensorsTab() {
    const { sensors, fetchSensors, createSensor, updateSensor, deleteSensor, loading } =
        useSensorsStore();
    const { currentUser } = useUserAuthStore();
    const [open, setOpen] = useState(false);
    const [editing, setEditing] = useState(null);

    useEffect(() => {
        if (!sensors.length) fetchSensors();
    }, [sensors.length, fetchSensors]);

    if (currentUser?.role !== "admin") {
        return <div className="p-4 text-gray-600">Access denied.</div>;
    }

    if (loading) return <div>Loading sensor units...</div>;

    return (
        <div>
            <div className="toolbar">
                <button onClick={() => { setEditing(null); setOpen(true); }}>+ Add Sensor</button>
            </div>


            <div className="table">
                <div className="table-row table-head">
                    <div>IMEI</div><div>Cell</div><div>Type</div><div></div>
                </div>
                {sensors.map((s) => (
                    <div className="table-row" key={s.id}>
                        <div>{s.IMEI}</div>
                        <div>{s.cellNumber || "-"}</div>
                        <div>{s.type}</div>
                        <div className="row-actions">
                            <button onClick={() => { setEditing(s); setOpen(true); }}>Edit</button>
                            <button className="danger" onClick={() => deleteSensor(s.id)}>Delete</button>
                        </div>
                    </div>
                ))}
            </div>


            <Modal open={open} onClose={() => setOpen(false)} title={editing ? "Edit Sensor" : "New Sensor"}>
                <SensorForm
                    initial={editing}
                    onSubmit={(data) => {
                        if (editing) updateSensor(editing.id, data); else createSensor(data);
                        setOpen(false); setEditing(null);
                    }}
                />
            </Modal>
        </div>
    );
}